/* Dragon Slayer Coach — theme.js
   Alpine.js loaded via CDN in layout/theme.liquid.
   Add shared vanilla JS utilities here. */

document.addEventListener('DOMContentLoaded', () => {

  // ── Announcement bar dismiss (session-persistent) ────────
  const bar     = document.querySelector('[data-announcement-bar]');
  const dismiss = document.querySelector('[data-announcement-dismiss]');
  if (bar && dismiss) {
    if (sessionStorage.getItem('ann-dismissed')) bar.style.display = 'none';
    dismiss.addEventListener('click', () => {
      bar.style.display = 'none';
      sessionStorage.setItem('ann-dismissed', '1');
    });
  }

  // ── Mobile menu toggle ───────────────────────────────────
  // querySelectorAll so both hamburger and X button work
  const menuBtns  = document.querySelectorAll('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const hamburger = document.querySelector('[data-menu-toggle]');
  if (menuBtns.length && mobileNav) {
    menuBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const open = mobileNav.getAttribute('aria-hidden') === 'false';
        mobileNav.setAttribute('aria-hidden', open ? 'true' : 'false');
        if (hamburger) hamburger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  // ── Header scroll state ──────────────────────────────────
  const header = document.querySelector('.hdr');
  if (header) {
    const setHeaderState = () => {
      header.classList.toggle('hdr--scrolled', window.scrollY > 8);
    };
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  // ── Notify-me expand + AJAX submit ───────────────────────
  // Used by: Stand With Us card, Be Counted card, Coaching tile
  // Searches wrap (not panel) for form — supports form-wraps-trigger structure
  document.querySelectorAll('[data-notify-wrap]').forEach(wrap => {
    const trigger = wrap.querySelector('[data-notify-trigger]');
    const panel   = wrap.querySelector('[data-notify-form]');
    const form    = wrap.querySelector('form');

    if (trigger && panel) {
      trigger.addEventListener('click', () => {
        trigger.style.display = 'none';
        panel.hidden = false;
        const emailInput = panel.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus();
      });
    }

    if (form) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const res = await fetch('/contact', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          if (res.ok) {
            if (panel) panel.hidden = true;
            const successMsg = wrap.querySelector('[data-notify-success]');
            if (successMsg) successMsg.hidden = false;
          } else {
            if (submitBtn) submitBtn.disabled = false;
          }
        } catch (_) {
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }
  });

});
